import { useCallback, useState } from 'react';

/**
 * Вызывает функцию callBack не более одного раза.
 * Использование: отправка события аналитики при начале редактирования.
 */
// todo: Перенести в shared
export const useOnceExecute = (callBack: () => void): () => void => {
    const [wasCalled, setWasCalled] = useState(false);

    return useCallback(() => {
        !wasCalled && setWasCalled((wasCalled) => {
            if (!wasCalled) {
                callBack();
            }

            return true;
        });
    }, [wasCalled, callBack]);
};
